import { useEffect } from 'react';
import {
  Combobox, useListCollection, Portal, useFilter,
} from '@chakra-ui/react';

import type { DispositionOptionType } from '../types';

type Props = {
  options: DispositionOptionType[];
  value: DispositionOptionType | null;
  onChange: (option: DispositionOptionType | null) => void;
};

const DispositionOptionSelect = ({
  options, value, onChange,
}: Props) => {
  const { contains } = useFilter({ sensitivity: 'base' })

  const { collection, filter, set } = useListCollection({
    initialItems: options,
    itemToValue: (item) => item.id,
    itemToString: (item) => item.name,
    filter: contains,
  });

  useEffect(() => {
    if (options) {
      set(options);
    }
  }, [options, set]);

  return (
    <Combobox.Root
      collection={collection}
      value={value ? [value.id] : []}
      onValueChange={({ items }) => onChange(items[0] || null)}
      onInputValueChange={(e) => filter(e.inputValue)}
      variant="outline"
    >
      <Combobox.Label>Opções de tabulação</Combobox.Label>
      <Combobox.Control>
        <Combobox.Input placeholder="Pesquisar..." />
        <Combobox.IndicatorGroup>
          <Combobox.ClearTrigger />
          <Combobox.Trigger />
        </Combobox.IndicatorGroup>
      </Combobox.Control>
      <Portal>
        <Combobox.Positioner>
          <Combobox.Content zIndex="popover">
            <Combobox.Empty>Nenhum item encontrado</Combobox.Empty>
            {collection.items.map((item) => (
              <Combobox.Item item={item} key={item.id}>
                {item.name}
                <Combobox.ItemIndicator />
              </Combobox.Item>
            ))}
          </Combobox.Content>
        </Combobox.Positioner>
      </Portal>
    </Combobox.Root>
  );
};

export default DispositionOptionSelect;
